import { inject, Injectable } from '@angular/core';
import { ApiHttpService } from '../../api-http.service';
import {
  CustomHttpResponse,
  SupplierComplaint,
  SupplierComplaintItem,
  SupplierComplaintSendInput,
} from '../../../models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SupplierComplaintService {
  apiService = inject(ApiHttpService<SupplierComplaint>);

  getById(id: string): Observable<SupplierComplaint> {
    return this.apiService
      .get(`/supplier_complaints/${id}`)
      .pipe(map((result: CustomHttpResponse<SupplierComplaint>) => result.body));
  }

  getPrefill(iri: string) {
    return this.apiService
      .get(`${iri}/send_prefill`)
      .pipe(map((result: CustomHttpResponse<SupplierComplaintSendInput>) => result.body));
  }

  create(supplierComplaint: SupplierComplaint): Observable<SupplierComplaint> {
    return this.apiService
      .post('/supplier_complaints', supplierComplaint)
      .pipe(map((result: CustomHttpResponse<SupplierComplaint>) => result.body));
  }

  send(iri: string, input: SupplierComplaintSendInput): Observable<SupplierComplaint> {
    return this.apiService
      .post(`${iri}/send`, input)
      .pipe(map((result: CustomHttpResponse<SupplierComplaint>) => result.body));
  }

  getItems(iri: string): Observable<SupplierComplaintItem[]> {
    return this.apiService
      .getMany(`${iri}/supplier_complaint_items`)
      .pipe(map((result) => result.body['hydra:member'] as unknown as SupplierComplaintItem[]));
  }

  update(iri: string, update: Partial<SupplierComplaint>): Observable<SupplierComplaint> {
    return this.apiService
      .patch(iri, update as SupplierComplaint)
      .pipe(map((result: CustomHttpResponse<SupplierComplaint>) => result.body));
  }

  updateStatus(iri: string, update: Partial<SupplierComplaint>): Observable<SupplierComplaint> {
    return this.apiService
      .patch(`${iri}/status`, update as SupplierComplaint)
      .pipe(map((result: CustomHttpResponse<SupplierComplaint>) => result.body));
  }

  delete(iri: string) {
    return this.apiService.delete(iri).pipe(map((result) => result));
  }
}
